export enum AdditionalKeysType {
  createBom = 'createBom',
  updateBom = 'updateBom',
  demand = 'demand',
  supply = 'supply',
  itemSite = 'itemSite',
  campaignItem = 'campaignItem'
}

export interface IAdditionalKeys {
  type?: AdditionalKeysType;
  parentKey?: string;
  childKey?: string;
}
